// removed by extract-text-webpack-plugin
module.exports = {"overflow":"_1vlTY","wrapper":"_3JXsE","container":"_2ZFGB"};


//////////////////
// WEBPACK FOOTER
// ./app/components/menu/menu.scss
// module id = 1583
// module chunks = 0